export default __webpack_public_path__ + "229b8c8d21f2ce3dbe890ab5b218fd1a.png";